module.exports = __webpack_public_path__ + "img/MZ-mob.3882099b.jpg";